import type { TourStep } from '../types';

export const designerPayoutsSteps: TourStep[] = [
  { target: '[data-tour="designer-payouts-balance"]', title: 'Баланс к выплате', content: 'Здесь показана сумма, доступная для ближайшей выплаты.' },
  { target: '[data-tour="designer-payouts-history"]', title: 'История выплат', content: 'Проверяйте даты, суммы и статусы предыдущих выплат.' },
];
